// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {AppBanner} from '@homeaway/react-app-banner';
import {EdapProvider} from '@homeaway/react-event-tracking';
import withLingua from '../withLingua/withLingua';
import type {LinguaProps} from '../withLingua/withLingua';
import type {State as ReduxState} from '../../reducers/index';
import {
    getDisplayName,
    getCtaLink,
    getFormattedTitle,
    getDeviceMessage
} from './utils/appBannerUtils';

const LINGUA_KEYS = {
    buttonLabel: 'serp.traveler.app.banner.button.label',
    description: 'serp.traveler.app.banner.description',
    ios_rating: 'ios.traveler.app.banner.ratings',
    android_rating: 'android.traveler.app.banner.ratings',
    ios_stars: 'ios.traveler.app.banner.stars',
    android_stars: 'android.traveler.app.banner.stars',
    title: 'serp.traveler.app.banner.title'
};

type StateProps = {
    isAndroid: boolean,
    isMobile: boolean,
    travelerApp: string
};

type InheritedProps = {
    globalMessageId: string
};

type Props = LinguaProps & StateProps & InheritedProps;

const AppDownloadBanner = ({
    isAndroid,
    isMobile,
    messages,
    globalMessageId,
    travelerApp
}: Props) => {
    const formattedBrandName = getDisplayName(travelerApp);
    const ctaLinkForBrand = getCtaLink(travelerApp);
    const titleFromLingua = messages[LINGUA_KEYS.title];
    const title = getFormattedTitle(titleFromLingua, formattedBrandName);
    const starsMessage = getDeviceMessage(
        isAndroid,
        messages[LINGUA_KEYS.android_stars],
        messages[LINGUA_KEYS.ios_stars]
    );
    const ratingMessage = getDeviceMessage(
        isAndroid,
        messages[LINGUA_KEYS.android_rating],
        messages[LINGUA_KEYS.ios_rating]
    );
    return (
        <EdapProvider>
            <AppBanner
                buttonLabel={messages[LINGUA_KEYS.buttonLabel]}
                ctaLink={ctaLinkForBrand}
                description={messages[LINGUA_KEYS.description]}
                isMobile={isMobile}
                rating={ratingMessage}
                showBanner
                stars={starsMessage}
                title={title}
                travelerApp={travelerApp}
                globalMessageId={globalMessageId}
                useCanonicalPath
            />
        </EdapProvider>
    );
};

const mapStateToProps = ({
    system: {isAndroid, isMobile, travelerApp}
}: ReduxState): StateProps => ({
    isAndroid,
    isMobile,
    travelerApp
});

export default compose(
    connect(mapStateToProps),
    withLingua({
        namespace: 'traveler/app-banner',
        category: 'messages'
    })
)(AppDownloadBanner);
